import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { getEopPages, isSupportedEopPlan } from '../../../app/eop-config/eop-page-config';

export const planPageAvailabilityGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const planSlug = getPlanSlug(childRoute);
  const requestedPage = getRequestedPage(childRoute);

  if (!requestedPage) {
    return true;
  }

  if (!planSlug) {
    return router.parseUrl('/not-found');
  }

  const allowedRoutes = new Set(getEopPages(planSlug).map(page => page.route));

  if (allowedRoutes.has(requestedPage)) {
    return true;
  }

  return router.parseUrl('/not-found');
};

function getPlanSlug(route: ActivatedRouteSnapshot) {
  const planSlug = route.paramMap.get('planSlug') ?? route.parent?.paramMap.get('planSlug');
  return isSupportedEopPlan(planSlug) ? planSlug : null;
}

function getRequestedPage(route: ActivatedRouteSnapshot): string | null {
  const pageRoute = route.paramMap.get('pageRoute');

  if (pageRoute) {
    return pageRoute;
  }

  const configuredPath = route.routeConfig?.path;

  // Empty paths and parameterized routes (e.g. custom-page/:customPageId) are
  // not gated by the static plan page list.
  if (!configuredPath || configuredPath === '' || configuredPath.includes(':')) {
    return null;
  }

  return configuredPath;
}
